@if (isOldBrowser) {
  <div class="old-b-wrap">
    <div class="old-b-wrap__style">
      <a class="js-close-old-b-wrap i-close" (click)="close()" translate="old-browser.label.close"></a>
      <div class="old-b-wrap__title" translate="old-browser.header"></div>
      <div class="old-b-wrap__sub-title" translate="old-browser.message.update-it"></div>
      <div class="old-b-wrap__list-img">
        <a [href]="'http://outdatedbrowser.com/' + languageA2" target="_blank">
          <img src="assets/img/browsers.png" alt="">
        </a>
      </div>
    </div>
  </div>
}
